module.exports = __webpack_public_path__ + "img/avatar9.7875163d.jpg";